export const initialValues = () => ({
  password: "",
  passwordConfirmation: "",
});
